import React, { useState } from "react"
import { Link, navigate } from "gatsby"
import { toast } from 'react-toastify'

import SEO from "../../components/seo"
import ToastContainer from "../../components/ToastContainer"
import Loading from "../../components/Loading"

import BG from './../../images/log-in.jpg'
import Logo from './../../images/logo.svg'
import { apiCall, validateToken } from '../../../Helper'
import { useEffect } from "react"


export default () => {
  const [mobile, setMobile] = useState((typeof localStorage !== 'undefined' && localStorage.getItem('mobile')) || '')
  const [code, setCode] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [codeSent, setCodeSent] = useState(false)
  const [hasPassword, setHasPassword] = useState(false)
  const [withPass, setWithPass] = useState(false)

  useEffect(() => { validateToken('/', true) }, [])

  function sendCode(resend = false, force = false) {
    if (mobile) {
      if (mobile.length === 9) {
        localStorage.setItem('mobile', mobile)
        setIsLoading(true)
        apiCall({
          url: '/user/newUserLogin',
          params: { mobile: "9" + mobile, force: force ? force : '' }
        }).then(res => {
          setIsLoading(false)
          if (res && res.data) {
            if (!resend && (res.data.code === 0 || res.data.code === 1)) {
              setHasPassword(res.data.has_password)
              setCodeSent(res.data.codeSent)
              setWithPass(res.data.withPass)
              // toast.success('کد با موفقیت ارسال شد')
              setCodeSent(true)
            } else toast.error(res.data.msg || 'مشکل در سیستم')
          } else toast.error('مشکل در سیستم')
        }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
      } else
        toast.warn('شماره موبایل وارد شده صحیح نیست')
    } else
      toast.warn('لطفا اطلاعات را وارد کنید')
  }

  function confirmCode() {
    if (code) {
      setIsLoading(true)
      apiCall({
        url: '/user/newUserLogin',
        method: 'put',
        data: { mobile: "9" + mobile, code, registration_id: window?.fb || '' }
      }).then(res => {
        setIsLoading(false)
        if (res && res.data) {
          if (res.data.code === 0) {
            localStorage.setItem("user", JSON.stringify(res.data.data))
            toast.success('ورود با موفقیت')
            setTimeout(navigate('/'), 1000)
          } else toast.error(res.data.msg || 'مشکل در سیستم')
        } else toast.error('مشکل در سیستم')
      }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
    } else {
      toast.warn('لطفا کد یکبار مصرف را وارد کنید')
    }
  }

  function loginWithPass() {
    if (password) {
      setIsLoading(true)
      apiCall({
        url: '/user/newUserLogin',
        method: 'post',
        data: { mobile: "9" + mobile, password }
      }).then(res => {
        setIsLoading(false)
        if (res && res.data) {
          if (res.data.code === 0) {
            localStorage.setItem("user", JSON.stringify(res.data.data))
            toast.success('ورود با موفقیت')
            setTimeout(navigate('/'), 1000)
          } else toast.error(res.data.msg || 'مشکل در سیستم')
        } else toast.error('مشکل در سیستم')
      }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
    } else {
      toast.warn('لطفا رمز عبور را وارد کنید')
    }
  }

  const renderMobileLogin = () => {
    return <form className="p-45 fixed radius-12 flexed fdir-col justify-between" style={{
      left: '10%',
      top: '50%',
      width: '25%',
      height: '35%',
      minHeight: 340,
      maxHeight: 700,
      maxWidth: 360,
      backgroundColor: 'rgba(256, 256, 256, 0.60)',
      backdropFilter: 'blur(16px)',
      transform: 'translate(0px, -50%)'
    }}
      onSubmit={e => {
        e.preventDefault()
        !isLoading ? sendCode() : toast.warn('لطفا منتظر بمانید')
      }}>
      <div className="px-16">
        <img src={Logo} alt="" />
      </div>
      <div className="text-center">
        <span className="blocked my-8 pb-8 font-10 text-lighter">جهت ورود شماره موبایل خود را وارد کنید</span>
      </div>
      <label className="flexed align-c m-auto" style={{ maxWidth: 140 }}>
        <span className="font-12 absolute" style={{ left: 8, top: 8 }}>09</span>
        <input dir="ltr" type="text"
          className="w-100 bg-none bd-none py-8 iran-sans font-12 pl-24"
          placeholder="-- --- -- --"
          style={{ letterSpacing: 4 }}
          onChange={e => {
            setMobile(e.target.value.length <= 9 ? e.target.value.replace(/\D/g, "") : mobile)
          }} value={mobile} />
      </label>
      <div className="pt-16 mb-16">
        <button
          disabled={isLoading}
          className="bg-tomato bd-none py-10 text-center text-top-nav iran-sans radius-8 w-100 font-12">ورود</button>
      </div>
      {/* <div className="mb-8 text-center">
        <button
          onClick={e => {
            e.preventDefault()
            if (mobile && mobile.length === 9) setCodeSent(true)
            else toast.warn('شماره موبایل وارد شده صحیح نیست')
          }}
          className="bg-none bd-none iran-sans font-10">کد را دریافت کردم</button>
      </div> */}
      <div className="text-center">
        <Link to="/" className="bg-none bd-none font-12">برگشت</Link>
      </div>
    </form>
  }

  const renderCodeSent = () => {
    return <form className="p-45 fixed radius-12 flexed fdir-col justify-between" style={{
      left: '10%',
      top: '50%',
      width: '25%',
      height: '35%',
      minHeight: 400,
      maxHeight: 700,
      maxWidth: 360,
      backgroundColor: 'rgba(256, 256, 256, 0.60)',
      backdropFilter: 'blur(16px)',
      transform: 'translate(0px, -50%)'
    }}
      onKeyDown={e => {
        if (e.keyCode === 13) {
          e.preventDefault()
          confirmCode()
        }
      }}
      onSubmit={e => {
        e.preventDefault()
        !isLoading ? confirmCode() : toast.warn('لطفا منتظر بمانید')
      }}>
      <div className="px-16">
        <img src={Logo} alt="" />
      </div>
      <div className="text-center">
        <span>کد تایید</span>
        <span className="blocked my-8 pb-8 font-10 text-lighter">لطفا کد ارسال شده را وارد کنید</span>
      </div>
      <div>
        <input type="text" dir="ltr"
          className="w-100 bg-none bd-none py-8 iran-sans font-10 mb-8 text-center" placeholder="- - - - -"
          style={{ letterSpacing: 4 }}
          onChange={e => setCode(e.target.value.length <= 5 ? e.target.value.replace(/\D/g, "") : code)} value={code} />
      </div>
      <div>
        <button className="font-10 bg-none bd-none iran-sans" onClick={e => {
          e.preventDefault()
          sendCode(true, true)
        }}>ارسال مجدد کد</button>
      </div>
      <div className="pt-16 mb-16">
        <button
          disabled={isLoading}
          className="bg-tomato bd-none py-10 text-center text-top-nav iran-sans radius-8 w-100 font-12">ورود</button>
      </div>
      {hasPassword && <div className="px-16 rtl text-center">
        <button
          onClick={e => {
            e.preventDefault()
            setWithPass(true)
          }}
          className="bg-none bd-none iran-sans font-10">ورود با رمز عبور</button>
      </div>}
      <div className="px-16 rtl text-center">
        <button
          onClick={e => {
            e.preventDefault()
            mobile && mobile.length === 9 && setCodeSent(false)
          }}
          className="bg-none bd-none iran-sans font-10">برگشت</button>
      </div>
    </form>
  }

  const renderWithPass = () => {
    return <form className="p-45 fixed radius-12 flexed fdir-col justify-between" style={{
      left: '10%',
      top: '50%',
      width: '25%',
      height: '35%',
      minHeight: 400,
      maxHeight: 700,
      maxWidth: 360,
      backgroundColor: 'rgba(256, 256, 256, 0.60)',
      backdropFilter: 'blur(16px)',
      transform: 'translate(0px, -50%)'
    }}
      onKeyDown={e => {
        if (e.keyCode === 13) {
          e.preventDefault()
          loginWithPass()
        }
      }}
      onSubmit={e => {
        e.preventDefault()
        !isLoading ? loginWithPass() : toast.warn('لطفا منتظر بمانید')
      }}>
      <div className="px-16">
        <img src={Logo} alt="" />
      </div>
      <div className="text-center">
        <span>رمز عبور</span>
        <span className="blocked my-8 pb-8 font-10 text-lighter">لطفا رمز عبور خود را وارد کنید</span>
      </div>
      <div>
        <input type="password"
          dir="ltr"
          className="w-100 bg-none bd-none py-8 iran-sans font-10 mb-8 text-center"
          placeholder="رمز عبور"
          onChange={e => setPassword(e.target.value)} value={password} />
      </div>
      <div className="pt-16 mb-16">
        <button
          disabled={isLoading}
          className="bg-tomato bd-none py-10 text-center text-top-nav iran-sans radius-8 w-100 font-12">ورود</button>
      </div>
      <div className="px-16 rtl text-center">
        <button
          onClick={e => {
            e.preventDefault()
            setWithPass(false)
            sendCode(false, true)
          }}
          className="bg-none bd-none iran-sans font-10">ورود با کد یکبار</button>
      </div>
      <div className="px-16 rtl text-center">
        <button
          onClick={e => {
            e.preventDefault()
            mobile && mobile.length === 9 && setCodeSent(false)
          }}
          className="bg-none bd-none iran-sans font-10">برگشت</button>
      </div>
    </form>
  }

  return (
    <div className="slideInTop">
      <SEO title="ورود با موبایل" />
      <ToastContainer />
      <Loading show={isLoading} full />
      <div className="h-100vh" style={{ backgroundImage: `url('${BG}')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>

        {!codeSent ?
          renderMobileLogin() :
          withPass ? renderWithPass() :
            renderCodeSent()
        }
      </div>
    </div>
  )
}
